import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useSearchSuggestionsQuery } from "@faire/retailer-visitor-shared/features/SearchSuggestions-v2/DataFetching/useSearchSuggestionsQuery";
import { setIntervalIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setIntervalIfPossible";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingSearchPlaceholder } from "@faire/retailer-visitor-shared/settings/useSettingSearchPlaceholder";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import shuffle from "lodash/shuffle";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
var CYCLING_SPEED = 5000;
var EMPTY_ARRAY = [];
export var useSearchPlaceholder = function() {
    var _useState = _sliced_to_array(useState(undefined), 2), placeholderSuggestion = _useState[0], setPlaceholderSuggestion = _useState[1];
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var getSettingSearchPlaceholder = useSettingSearchPlaceholder();
    var data = useSearchSuggestionsQuery("", {
        enabled: isLoggedInRetailer
    }).data;
    var apparelSearchPlaceholders = useMemo(function() {
        if (!isLoggedInRetailer) {
            return EMPTY_ARRAY;
        }
        return shuffle(data === null || data === void 0 ? void 0 : data.search_recommendations).map(function(param) {
            var name = param.name;
            return strictLocalize({
                id: "cytocW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Search for \""
                    },
                    {
                        type: 1,
                        value: "searchProductName"
                    },
                    {
                        type: 0,
                        value: "\""
                    }
                ]
            }, {
                searchProductName: name !== null && name !== void 0 ? name : ""
            });
        });
    }, [
        data === null || data === void 0 ? void 0 : data.search_recommendations,
        isLoggedInRetailer,
        strictLocalize
    ]);
    var cycleInterval = useRef(undefined);
    var currentIndex = useRef(0);
    var emptySuggestions = apparelSearchPlaceholders.length === 0;
    var loggedOutPlaceholder = useMemo(function() {
        switch(getSettingSearchPlaceholder){
            case IThreeVariantXP.Bucket.VARIANT_2:
                return strictLocalize({
                    id: "zxneYt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search products for your store"
                        }
                    ]
                });
            case IThreeVariantXP.Bucket.VARIANT_3:
                return strictLocalize({
                    id: "amDmND",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search products or brands for your store"
                        }
                    ]
                });
            default:
                return strictLocalize({
                    id: "KChW/3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Search wholesale products or brands"
                        }
                    ]
                });
        }
    }, [
        getSettingSearchPlaceholder,
        strictLocalize
    ]);
    var placeholder = useMemo(function() {
        if (placeholderSuggestion) {
            return placeholderSuggestion;
        }
        var loggedInPlaceholder = strictLocalize({
            id: "z7d8Af",
            defaultMessage: [
                {
                    type: 0,
                    value: "Search products or brands"
                }
            ]
        });
        return isLoggedInRetailer ? loggedInPlaceholder : loggedOutPlaceholder;
    }, [
        placeholderSuggestion,
        strictLocalize,
        isLoggedInRetailer
    ]);
    var updatePlaceholderSuggestion = useCallback(function() {
        if (emptySuggestions) {
            return;
        }
        setPlaceholderSuggestion(apparelSearchPlaceholders[currentIndex.current]);
        currentIndex.current = (currentIndex.current + 1) % apparelSearchPlaceholders.length;
    }, [
        apparelSearchPlaceholders,
        emptySuggestions
    ]);
    var startPlaceholderCycling = useCallback(function() {
        if (cycleInterval.current) {
            return;
        }
        updatePlaceholderSuggestion();
        cycleInterval.current = setIntervalIfPossible(updatePlaceholderSuggestion, CYCLING_SPEED);
    }, [
        updatePlaceholderSuggestion
    ]);
    var stopPlaceholderCycling = useCallback(function() {
        if (cycleInterval.current) {
            clearInterval(cycleInterval.current);
            setPlaceholderSuggestion(undefined);
            cycleInterval.current = undefined;
        }
    }, []);
    useEffect(function() {
        return function() {
            clearInterval(cycleInterval.current);
        };
    });
    return {
        placeholder: placeholder,
        startPlaceholderCycling: startPlaceholderCycling,
        stopPlaceholderCycling: stopPlaceholderCycling
    };
};
